import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { request } from './ApiModule';
import AuthenticationUtil from '../util/AuthenticationUtil';
import SessionStorageUtil from '../util/SessionStorageUtil';
import {
    COMMUNITY_FAQ_PATH,
    COMMUNITY_NOTICE_PATH,
    COMMUNITY_QNA_PATH,
    MAIN_PATH,
    PATH_DELIMITER,
    SUBJECT_SEARCH_BODY_PATH,
    SYSTEM_USER_PATH,
} from '../constant/Constant';
import NullCheckUtil from '../util/NullCheckUtil';
import { sessionValidTime } from '../util/DateTimeUtil';
import { useNavigate } from 'react-router-dom';

const NoMovePath = [SUBJECT_SEARCH_BODY_PATH, COMMUNITY_NOTICE_PATH, COMMUNITY_FAQ_PATH, COMMUNITY_QNA_PATH];

const BASE = 'login';
const ACTION_LOGIN = BASE + PATH_DELIMITER + 'ACTION_LOGIN';
const HANDLE_LOGIN = BASE + PATH_DELIMITER + 'HANDLE_LOGIN';
const ACTION_LOGOUT = BASE + PATH_DELIMITER + 'ACTION_LOGOUT';
const HANDLE_LOGOUT = BASE + PATH_DELIMITER + 'HANDLE_LOGOUT';
const ACTION_CAPTCHA = BASE + PATH_DELIMITER + 'ACTION_CAPTCHA';
const INIT_CAPTCHA = BASE + PATH_DELIMITER + 'INIT_CAPTCHA';
const HANDLE_CAPTCHA = BASE + PATH_DELIMITER + 'HANDLE_CAPTCHA';
const ACTION_PSWD_UPDT_DT = BASE + PATH_DELIMITER + 'ACTION_PSWD_UPDT_DT';
const ACTION_SESSION_EXTEND = BASE + PATH_DELIMITER + 'ACTION_SESSION_EXTEND';

export const actionLogin = createAction(ACTION_LOGIN);
export const handleLogin = createAction(HANDLE_LOGIN);
export const actionLogout = createAction(ACTION_LOGOUT);
export const handleLogout = createAction(HANDLE_LOGOUT);
export const actionInitCaptcha = createAction(INIT_CAPTCHA);
export const actionCaptcha = createAction(ACTION_CAPTCHA);
export const actionUserPswdUpdtDt = createAction(ACTION_PSWD_UPDT_DT);
export const actionSessionExtend = createAction(ACTION_SESSION_EXTEND);

export function* loginSagas() {
    yield takeEvery(ACTION_LOGIN, actionLoginSaga);
    yield takeEvery(ACTION_LOGOUT, actionLogoutSaga);
    yield takeEvery(ACTION_CAPTCHA, actionCaptchaSaga);
    yield takeEvery(ACTION_PSWD_UPDT_DT, actionUserPswdUpdtDtSaga);
    yield takeEvery(ACTION_SESSION_EXTEND, actionSessionExtendSaga);
}

function* actionLoginSaga({ payload }) {
    const result = yield call(request, {
        method: 'post',
        url: '/auth/login',
        data: payload,
    });
    if (NullCheckUtil.isNotNull(result)) {
        AuthenticationUtil.set(result);
        SessionStorageUtil.setSessionValidTime(sessionValidTime());
        yield put({ type: HANDLE_LOGIN });
        payload.callback(result.pwChangeRequired);
    }
}

const checkPath = (pathname) => {
    var result = NoMovePath.find((item) => pathname.includes(item));
    return result != undefined;
};

function* actionLogoutSaga({ payload: { data, msg } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/auth/logout',
        data,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        AuthenticationUtil.set(result);
        window.history.pushState({}, '', SYSTEM_USER_PATH);
        window.location.reload();
    } else {
        AuthenticationUtil.clear();
        yield put({ type: HANDLE_LOGOUT });

        if (checkPath(window.location.pathname)) {
            window.history.pushState({}, '', window.location.pathname);
            window.location.reload();
        } else {
            window.history.pushState({}, '', MAIN_PATH);
            window.location.reload();
        }
    }

    msg && alert(msg);
}

function* actionCaptchaSaga({ payload }) {
    const result = yield call(request, {
        method: 'post',
        url: '/auth/recaptcha',
        data: payload,
    });
    if (NullCheckUtil.isNotNull(result) && result) {
        yield put({ type: HANDLE_CAPTCHA });
    }
}

function* actionUserPswdUpdtDtSaga({ payload: { data } }) {
    yield call(request, {
        method: 'put',
        url: `/api/users/${data.userId}/extension`,
    });
}

function* actionSessionExtendSaga({}) {
    yield call(request, {
        method: 'get',
        url: `/auth/session-extend`,
    });
}

const initialState = {
    logged: AuthenticationUtil.isLogin(),
    disabled: true,
};

const module = handleActions(
    {
        [HANDLE_LOGIN]: (state) => ({ ...state, logged: true }),
        [HANDLE_LOGOUT]: (state) => ({ ...state, logged: false }),
        [INIT_CAPTCHA]: (state) => ({ ...state, disabled: true }),
        [HANDLE_CAPTCHA]: (state) => ({ ...state, disabled: false }),
    },
    initialState,
);

export default module;
